import { useDispatch } from 'react-redux';
import { checkAuthState } from '../../store/authSlice';
import classes from './SearchError.module.css';

const SearchError = ({ error, onRetry }) => {
  const dispatch = useDispatch();

  const getErrorContent = () => {
    if (error?.message?.includes('401') || error?.status === 401) {
      return {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#FEF2F2"/>
            <path d="M24 12C17.373 12 12 17.373 12 24C12 30.627 17.373 36 24 36C30.627 36 36 30.627 36 24C36 17.373 30.627 12 24 12ZM26 28H22V32H26V28ZM26 16H22V26H26V16Z" fill="#DC2626"/>
          </svg>
        ),
        title: "Authentifizierung fehlgeschlagen",
        message: "Deine Anmeldung ist abgelaufen. Bitte melde dich erneut an, um fortzufahren.",
        actionText: "Anmelden",
        secondaryActionText: "Erneut versuchen",
        onAction: () => {
          // Trigger sign in modal or redirect to sign in
          dispatch(checkAuthState());
        }
      };
    }

    if (error?.message?.includes('Network') || error?.message?.includes('fetch')) {
      return {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#FEF2F2"/>
            <path d="M24 8C15.163 8 8 15.163 8 24C8 32.837 15.163 40 24 40C32.837 40 40 32.837 40 24C40 15.163 32.837 8 24 8ZM22 30V26H26V30H22ZM22 18V22H26V18H22Z" fill="#DC2626"/>
          </svg>
        ),
        title: "Verbindungsfehler",
        message: "Wir können derzeit keine Studios laden. Bitte überprüfe deine Internetverbindung.",
        actionText: "Erneut versuchen",
        onAction: onRetry
      };
    }

    // Default error
    return {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="24" fill="#FEF2F2"/>
          <path d="M24 12C17.373 12 12 17.373 12 24C12 30.627 17.373 36 24 36C30.627 36 36 30.627 36 24C36 17.373 30.627 12 24 12ZM26 28H22V32H26V28ZM26 16H22V26H26V16Z" fill="#DC2626"/>
        </svg>
      ),
      title: "Ein Fehler ist aufgetreten",
      message: "Wir konnten die Studios nicht laden. Bitte versuche es später erneut.",
      actionText: "Erneut versuchen",
      onAction: onRetry
    };
  };

  const errorContent = getErrorContent();

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorContent}>
        {errorContent.icon}
        <h3 className="titleSemibold">{errorContent.title}</h3>
        <p className="mediumLarge" style={{ color: "var(--dark-grey-2)", textAlign: "center" }}>
          {errorContent.message}
        </p>
        <div className={classes.buttonContainer}>
          <button 
            className={`${classes.primaryButton} regularLarge`}
            onClick={errorContent.onAction}
          >
            {errorContent.actionText}
          </button>
          {errorContent.secondaryActionText && (
            <button 
              className={`${classes.secondaryButton} regularLarge`}
              onClick={onRetry}
            >
              {errorContent.secondaryActionText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchError;